import { getAllAvatarNames } from '../../../api/user';
// Set of Two different Pools for default avatar names
//      that will be randomly assigned to the default
//      avatar upon sign up for the first time.
// Pool A - Positive Adjectives
// Pool B - Nouns

const avatarNamePoolA = [
    'Happy', 'Joyful', 'Blissful',
    'Radiant', 'Cheerful', 'Lively',
    'Vibrant', 'Exuberant', 'Optimistic',
    'Playful', 'Grateful', 'Content',
    'Delighted', 'Ecstatic', 'Elated',
    'Enthusiastic', 'Smart', 'Pleased',
    'Cunning', 'Jovial', 'Positive', 'Bubbly',
    'Glorious', 'Gleeful', 'Energetic',
    'Satisfied', 'Hopeful', 'Cheery',
    'Fulfilled', 'Radiant', 'Wholesome',
    'Amiable', 'Affectionate', 'Loving',
    'Kind-hearted', 'Warm', 'Tender',
    'Friendly', 'Compassionate', 'Empathetic',
    'Sympathetic', 'Caring', 'Considerate',
    'Generous', 'Charismatic', 'Inspiring',
    'Creative', 'Imaginative', 'Ingenious',
    'Resourceful', 'Determined', 'Persistent',
    'Resilient', 'Tenacious', 'Ambitious',
    'Focused', 'Confident', 'Courageous',
    'Fearless', 'Strong', 'Dynamic',
    'Empowered', 'Assertive', 'Genuine',
    'Authentic', 'Honest', 'Trustworthy',
    'Reliable', 'Responsible', 'Ethical',
    'Respectful', 'Polite', 'Considerate',
    'Tolerant', 'Zealous', 'Calm', 'Serene',
    'Tranquil', 'Peaceful', 'Composed',
    'Grounded', 'Stable', 'Balanced',
    'Harmonious', 'Gracious', 'Elegant',
    'Sophisticated', 'Charming',
    'Alluring', 'Enchanting', 'Magnetic',
    'Captivating', 'Uplifting', 'Refreshing',
    'Revitalized', 'Rejuvenated', 'Invigorated',
    'Spirited', 'Dynamic',
];

const avatarNamePoolB = [
    'Tiger', 'Guitar', 'Elephant',
    'Sunshine', 'Telescope', 'Butterfly',
    'Penguin', 'Laptop', 'Dolphin',
    'Bookshelf', 'Owl', 'Piano', 'Suitcase', 'Whale',
    'Cheetah', 'Microphone', 'Koala', 'Sunglasses',
    'Friendship', 'Monkey', 'Backpack', 'Swan',
    'Binoculars', 'Flamingo', 'Kangaroo', 'Drum',
    'Camera', 'Horse', 'Clock', 'Rider', 'Zebra',
    'Seahorse', 'Umbrella', 'Hummingbird', 'Blades',
    'Dragon', 'Dragonfly', 'Candle', 'Wizard', 'Hedgehog',
    'Wallet', 'Chain', 'Desk', 'Brush', 'Monitor',
    'Smartphone', 'Eagle', 'Notebook', 'Water',
    'Bear', 'Parrot', 'Alligator', 'Globe', 'Fish', 'Moonlight',
    'Peacock', 'King', 'Queen', 'Gladiator', 'Sparta', 'Walker',
    'Runner', 'Sunflower', 'Rose', 'Lily', 'Daisy', 'Lion',
    'Galaxy', 'Warrior', 'Nebula', 'Latern', 'Thunder',
    'Unicorn', 'Phoenix', 'Ember', 'Odessey', 'Orion',
    'Scorpio', 'Shark', 'GoldFish', 'Seel', 'Lion',
    'BigStar', 'Violin', 'Speaker', 'Comet', 'Polaris',
    'Beacon', 'Elixir', 'Treasurer', 'Jewel', 'Octopus',
    'Sparrow', 'Hammer', 'Platypus', 'Bison', 'Lynx', 'Blanket',
    'Shiny',
];

const validateGeneratedName = async(name) => {
    const avatarNames = await getAllAvatarNames();
    if (avatarNames.includes(name)) {
        return false;
    }
    return true;
};

const generate = () => {
    const randomIndexA = Math.floor(Math.random() * avatarNamePoolA.length);
    const randomIndexB = Math.floor(Math.random() * avatarNamePoolB.length);
    const randomName = avatarNamePoolA[randomIndexA] + avatarNamePoolB[randomIndexB];
    return randomName;
};

const getRandomAvatarName = () => {
    const randomName = generate();
    const res = validateGeneratedName(randomName);
    if (res) {
        // Can use this name - no duplicates
        return randomName;
    } else {
        getRandomAvatarName();
    }
};

export { getRandomAvatarName };
